export default "__VITE_ASSET__C81IswDj__"